export default "__VITE_ASSET__C3$fw1i6__"